module.exports = __webpack_public_path__ + "img/TeacherJaniceK.4d34debb.png";